module.exports = __webpack_public_path__ + "static/media/view4.bfbb65b1.jpg";